// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contact-item-info__table-body tr {
    border: none;
    padding: 1rem;
}

.contact-item-info__table-body td {
    padding: 6px 0;
    text-align: left;
    vertical-align: middle;
    height:auto;
}

.contact-item-info__avatar-container {
    width: 30%;
}

.contact-item-info__created-time-cell {
    line-height: 5rem;
    margin: auto;
    margin-top: 2rem;
}

.contact-item-info__external-id-cell,
.contact-item-info__localization-cell {
    margin: auto;
    line-height: 5rem;
}

.contact-item-info__container {
    height: 100%;
    padding: 3% 10%;
    display: flex;
    flex-direction: column;
    overflow: auto;
    position: relative;
}

.contact-item-info__table {
    width: 72rem;
}

.contact-item-info__actions {
    width: 100%;
    display: flex;
    justify-content: center;
}

.contact-item-info__btn-save {
    margin-right: 0.3rem;
}

.contact-item-info__btn-delete {
    background-color: #d22e37;
    margin-left: 0.3rem;
}

.contact-item-info__btn-delete:hover {
    background-color: #e74c3c;
}

.contact-item-info__avatar {
    width: 8rem !important;
    height: 8rem !important;
    border-radius: 50%;
    cursor: pointer;
}

.contact-item-info__avatar svg {
    width: 100% !important;
    height: 100% !important;
}

.contact-item-info__phone-input-cell {
    display: flex;
    flex-direction: row;
    max-width: 19.2rem;
}

.contact-item-info__merge-button {
    line-height: 0;
    width: 4rem;
    height: 1.2rem;
    margin: auto 0;
    margin-left: 2.8rem;
    padding: 0;
    font-size: 0.6rem;
}

.contact-item-info__comments-input-container {
    height: 6.3rem;
}

.contact-item-info__comments-input {
    resize: none;
    border-left-style: hidden;
    border-top-style: hidden;
    border-right-style: hidden;
    outline: none;
    font-size: 1.6rem;
    line-height: 1.8rem;
    height: auto;
    max-height: 5.6rem;
}

.open-comment-in-full-screen{
    border: 0;
    background: transparent;
    cursor: pointer;
}

.open-comment-in-full-screen:hover{
    background: transparent;
    color: #26a69a;
}

.open-comment-in-full-screen:focus{
    background: transparent;
}

.contact-item-info__table .contact-item-info__chatName-input-container input {
    padding-bottom: 5px !important;
    height: auto;
    margin-top: 16px;
}

.contact-item-info__table .contact-item-info__phone-input-cell input {
    padding-bottom: 5px !important;
    height: auto;
    margin-top: 16px;
}

.contact-item-info__table .contact-item-info__comments-input-container textarea,
.contact-item-info__table .contact-item-info__comments-input-container .contact-item-info__comments-input {
    padding-top: 3.2rem;
    padding-bottom: 5px;
    box-sizing: border-box;
    height: 100%;
    min-height: 100%;
}`, "",{"version":3,"sources":["webpack://./src/app/contact/contact-main/contact-list/contact-item/contact-item-info/ContactItemInfo.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,iBAAiB;IACjB,YAAY;IACZ,gBAAgB;AACpB;;AAEA;;IAEI,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,aAAa;IACb,sBAAsB;IACtB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,cAAc;IACd,cAAc;IACd,mBAAmB;IACnB,UAAU;IACV,iBAAiB;AACrB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,yBAAyB;IACzB,wBAAwB;IACxB,0BAA0B;IAC1B,aAAa;IACb,iBAAiB;IACjB,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,SAAS;IACT,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,8BAA8B;IAC9B,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,8BAA8B;IAC9B,YAAY;IACZ,gBAAgB;AACpB;;AAEA;;IAEI,mBAAmB;IACnB,mBAAmB;IACnB,sBAAsB;IACtB,YAAY;IACZ,gBAAgB;AACpB","sourcesContent":[".contact-item-info__table-body tr {\r\n    border: none;\r\n    padding: 1rem;\r\n}\r\n\r\n.contact-item-info__table-body td {\r\n    padding: 6px 0;\r\n    text-align: left;\r\n    vertical-align: middle;\r\n    height:auto;\r\n}\r\n\r\n.contact-item-info__avatar-container {\r\n    width: 30%;\r\n}\r\n\r\n.contact-item-info__created-time-cell {\r\n    line-height: 5rem;\r\n    margin: auto;\r\n    margin-top: 2rem;\r\n}\r\n\r\n.contact-item-info__external-id-cell,\r\n.contact-item-info__localization-cell {\r\n    margin: auto;\r\n    line-height: 5rem;\r\n}\r\n\r\n.contact-item-info__container {\r\n    height: 100%;\r\n    padding: 3% 10%;\r\n    display: flex;\r\n    flex-direction: column;\r\n    overflow: auto;\r\n    position: relative;\r\n}\r\n\r\n.contact-item-info__table {\r\n    width: 72rem;\r\n}\r\n\r\n.contact-item-info__actions {\r\n    width: 100%;\r\n    display: flex;\r\n    justify-content: center;\r\n}\r\n\r\n.contact-item-info__btn-save {\r\n    margin-right: 0.3rem;\r\n}\r\n\r\n.contact-item-info__btn-delete {\r\n    background-color: #d22e37;\r\n    margin-left: 0.3rem;\r\n}\r\n\r\n.contact-item-info__btn-delete:hover {\r\n    background-color: #e74c3c;\r\n}\r\n\r\n.contact-item-info__avatar {\r\n    width: 8rem !important;\r\n    height: 8rem !important;\r\n    border-radius: 50%;\r\n    cursor: pointer;\r\n}\r\n\r\n.contact-item-info__avatar svg {\r\n    width: 100% !important;\r\n    height: 100% !important;\r\n}\r\n\r\n.contact-item-info__phone-input-cell {\r\n    display: flex;\r\n    flex-direction: row;\r\n    max-width: 19.2rem;\r\n}\r\n\r\n.contact-item-info__merge-button {\r\n    line-height: 0;\r\n    width: 4rem;\r\n    height: 1.2rem;\r\n    margin: auto 0;\r\n    margin-left: 2.8rem;\r\n    padding: 0;\r\n    font-size: 0.6rem;\r\n}\r\n\r\n.contact-item-info__comments-input-container {\r\n    height: 6.3rem;\r\n}\r\n\r\n.contact-item-info__comments-input {\r\n    resize: none;\r\n    border-left-style: hidden;\r\n    border-top-style: hidden;\r\n    border-right-style: hidden;\r\n    outline: none;\r\n    font-size: 1.6rem;\r\n    line-height: 1.8rem;\r\n    height: auto;\r\n    max-height: 5.6rem;\r\n}\r\n\r\n.open-comment-in-full-screen{\r\n    border: 0;\r\n    background: transparent;\r\n    cursor: pointer;\r\n}\r\n\r\n.open-comment-in-full-screen:hover{\r\n    background: transparent;\r\n    color: #26a69a;\r\n}\r\n\r\n.open-comment-in-full-screen:focus{\r\n    background: transparent;\r\n}\r\n\r\n.contact-item-info__table .contact-item-info__chatName-input-container input {\r\n    padding-bottom: 5px !important;\r\n    height: auto;\r\n    margin-top: 16px;\r\n}\r\n\r\n.contact-item-info__table .contact-item-info__phone-input-cell input {\r\n    padding-bottom: 5px !important;\r\n    height: auto;\r\n    margin-top: 16px;\r\n}\r\n\r\n.contact-item-info__table .contact-item-info__comments-input-container textarea,\r\n.contact-item-info__table .contact-item-info__comments-input-container .contact-item-info__comments-input {\r\n    padding-top: 3.2rem;\r\n    padding-bottom: 5px;\r\n    box-sizing: border-box;\r\n    height: 100%;\r\n    min-height: 100%;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
